// Language translations
export const translations = {
  en: {
    // Header
    appName: 'Mission Police',
    loginWithGoogle: 'Login with Google',
    logout: 'Logout',
    dashboard: 'Dashboard',
    
    // Home page
    heroTitle: 'Mission Police Test Series',
    heroSubtitle: 'Prepare for Police Bharti exam with our comprehensive test series. Only ₹10 per test with instant results.',
    startPreparing: 'Start Preparing Now',
    
    // Features
    questionsCount: '10 Questions',
    focusedTests: 'Focused tests with quality questions',
    instantResults: 'Instant Results',
    detailedSolutions: 'Get detailed solutions immediately',
    expertContent: 'Expert Content',
    examSpecialists: 'Created by exam specialists',
    affordablePrice: '₹10 Only',
    qualityPreparation: 'Affordable quality preparation',
    
    // Categories
    testCategories: 'Test Categories',
    generalKnowledge: 'General Knowledge',
    mathematics: 'Mathematics',
    reasoning: 'Reasoning',
    marathi: 'Marathi',
    
    // Dashboard
    testsTaken: 'Tests Taken',
    walletBalance: 'Wallet Balance',
    welcomeBack: 'Welcome back!',
    browseTests: 'Browse Tests',
    allTests: 'All Tests',
    questions: 'Questions',
    minutes: 'Minutes',
    buyTakeTest: 'Buy & Take Test',
    noTestsAvailable: 'No tests available in this category.',
    
    // Test taking
    timeLeft: 'Time Left',
    question: 'Question',
    of: 'of',
    answered: 'answered',
    previous: 'Previous',
    next: 'Next',
    submitTest: 'Submit Test',
    questionNavigator: 'Question Navigator',
    
    // Results
    testCompleted: 'Test Completed!',
    youScored: 'You scored',
    outOf: 'out of',
    questionsCorrectly: 'questions correctly',
    backToDashboard: 'Back to Dashboard',
    explanation: 'Explanation',
    
    // Messages
    insufficientBalance: 'Insufficient balance. Please add money to wallet.',
    testPurchased: 'Test purchased successfully!',
    purchaseFailed: 'Purchase failed. Please try again.',
    loginFailed: 'Login failed. Please try again.',
    paymentSuccessful: 'Payment successful!',
    paymentCancelled: 'Payment cancelled',
    
    // Admin
    adminDashboard: 'Admin Dashboard',
    totalUsers: 'Total Users',
    totalTests: 'Total Tests',
    totalRevenue: 'Total Revenue',
    testsManagement: 'Tests Management',
    users: 'Users',
    addTest: 'Add Test'
  },
  
  mr: {
    // Header
    appName: 'मिशन पोलीस',
    loginWithGoogle: 'Google ने लॉगिन करा',
    logout: 'लॉगआउट',
    dashboard: 'डॅशबोर्ड',
    
    // Home page
    heroTitle: 'मिशन पोलीस चाचणी मालिका',
    heroSubtitle: 'आमच्या व्यापक चाचणी मालिकेसह पोलीस भरती परीक्षेची तयारी करा. फक्त ₹१० प्रति चाचणी तत्काळ परिणामांसह.',
    startPreparing: 'आता तयारी सुरू करा',
    
    // Features
    questionsCount: '१० प्रश्न',
    focusedTests: 'गुणवत्तापूर्ण प्रश्नांसह केंद्रित चाचण्या',
    instantResults: 'तत्काळ परिणाम',
    detailedSolutions: 'तत्काळ तपशीलवार उपाय मिळवा',
    expertContent: 'तज्ञ सामग्री',
    examSpecialists: 'परीक्षा तज्ञांनी तयार केलेले',
    affordablePrice: 'फक्त ₹१०',
    qualityPreparation: 'परवडणारी गुणवत्तापूर्ण तयारी',
    
    // Categories
    testCategories: 'चाचणी श्रेणी',
    generalKnowledge: 'सामान्य ज्ञान',
    mathematics: 'गणित',
    reasoning: 'तर्कशुद्धता',
    marathi: 'मराठी',
    
    // Dashboard
    testsTaken: 'घेतलेल्या चाचण्या',
    walletBalance: 'वॉलेट शिल्लक',
    welcomeBack: 'परत स्वागत!',
    browseTests: 'चाचण्या पहा',
    allTests: 'सर्व चाचण्या',
    questions: 'प्रश्न',
    minutes: 'मिनिटे',
    buyTakeTest: 'खरेदी करा आणि चाचणी घ्या',
    noTestsAvailable: 'या श्रेणीत कोणत्याही चाचण्या उपलब्ध नाहीत.',
    
    // Test taking
    timeLeft: 'उरलेला वेळ',
    question: 'प्रश्न',
    of: 'पैकी',
    answered: 'उत्तर दिले',
    previous: 'मागील',
    next: 'पुढील',
    submitTest: 'चाचणी सबमिट करा',
    questionNavigator: 'प्रश्न नेव्हिगेटर',
    
    // Results
    testCompleted: 'चाचणी पूर्ण झाली!',
    youScored: 'तुम्ही मिळवले',
    outOf: 'पैकी',
    questionsCorrectly: 'प्रश्न बरोबर',
    backToDashboard: 'डॅशबोर्डवर परत जा',
    explanation: 'स्पष्टीकरण',
    
    // Messages
    insufficientBalance: 'अपुरी शिल्लक. कृपया वॉलेटमध्ये पैसे जोडा.',
    testPurchased: 'चाचणी यशस्वीरित्या खरेदी केली!',
    purchaseFailed: 'खरेदी अयशस्वी. कृपया पुन्हा प्रयत्न करा.',
    loginFailed: 'लॉगिन अयशस्वी. कृपया पुन्हा प्रयत्न करा.',
    paymentSuccessful: 'पेमेंट यशस्वी!',
    paymentCancelled: 'पेमेंट रद्द केले',
    
    // Admin
    adminDashboard: 'प्रशासक डॅशबोर्ड',
    totalUsers: 'एकूण वापरकर्ते',
    totalTests: 'एकूण चाचण्या',
    totalRevenue: 'एकूण महसूल',
    testsManagement: 'चाचण्या व्यवस्थापन',
    users: 'वापरकर्ते',
    addTest: 'चाचणी जोडा'
  }
}

// Language context
export const getTranslation = (key, language = 'en') => {
  return translations[language]?.[key] || translations.en[key] || key
}